import React, { useContext, useState } from "react";
import {
  Box,
  Flex,
  Icon,
  useColorModeValue,
  Link,
  Drawer,
  DrawerContent,
  useDisclosure,
  BoxProps,
  FlexProps,
  Image,
  DrawerOverlay,
  useBreakpointValue,
  CloseButton,
  Popover,
  PopoverContent,
  PopoverBody,
  Tooltip,
  PopoverTrigger,
  Portal,
} from "@chakra-ui/react";

import { IconType } from "react-icons";

import {
  FaChartPie,
  FaListCheck,
} from "react-icons/fa6";

import {
  AiOutlineReconciliation,
} from "react-icons/ai";

import { MdOutlinePolicy } from "react-icons/md";

import { IoWarningOutline } from "react-icons/io5";
import { IoMdHelp } from "react-icons/io";

import { HiMiniDevicePhoneMobile } from "react-icons/hi2";

import { RiSwitchLine } from "react-icons/ri";

import { AppContext } from "AppProvider/AppContext";

import { BASE_PATH } from "utils/env";

interface LinkItemProps {
  name: string;
  icon: IconType;
  role: string;
  url: string;
  items?: LinkItemProps[];
  permission?: string;
}

const OrganisationLinkItems: Array<LinkItemProps> = [
  {
    name: "Dashboard",
    icon: FaChartPie,
    role: "Dashboard",
    url: "#",
    permission: "canViewOrderDashboard",
  },
  // {
  //   name: "Ads",
  //   icon: HiMiniDevicePhoneMobile,
  //   role: "Ads",
  //   url: "#",
  //   permission: "canViewAds",
  // },
  {
    name: "Sdk Orders",
    icon: FaListCheck,
    role: "Orders",
    url: "#",
    permission: "canViewSdkOrders",
  },
  {
    name: "Orders",
    icon: FaListCheck,
    role: "Dashboard",
    url: "#",
    permission: "canViewOrders",
  },
  // {
  //   name: "Reconciliation",
  //   icon: AiOutlineReconciliation,
  //   role: "Dashboard",
  //   url: "#",
  //   permission: "canViewReconciliation",
  // },
  // {
  //   name: "Payment",
  //   icon: AiOutlineReconciliation,
  //   role: "Dashboard",
  //   url: "#",
  //   permission: "canViewPayment",
  // },
  {
    name: "Issues",
    icon: IoWarningOutline,
    role: "Dashboard",
    url: "#",
    permission: "canViewIssue",
  },
  {
    name: "FAQs",
    icon: IoMdHelp,
    role: "Faqs",
    url: "#",
    permission: "canViewFaqs",
  },
];

const AdminLinkItems: Array<LinkItemProps> = [
  {
    name: "Settings",
    icon: MdOutlinePolicy,
    role: "Dashboard",
    url: "#",
    items: [
      {
        name: "Users",
        icon: RiSwitchLine,
        role: "Dashboard",
        url: "#",
        permission: "canViewUsers",
      },
    ],
  },
];

type setActivePage = React.Dispatch<
  React.SetStateAction<string>
>;

type Props = {
  activePage: string;
  setActivePage: setActivePage;
  openMobileSideDrawer: boolean;
  setOpenMobileSideDrawer: any;
};

export default function Sidebar({
  activePage,
  setActivePage,
  openMobileSideDrawer,
  setOpenMobileSideDrawer,
}: Props) {
  const { isOpen, onClose } = useDisclosure();

  const [hideName, setHideName] = useState(true);

  return (
    <>
      {/* Desktop Sidebar */}

      <Box
        minH="100vh"
        bg={useColorModeValue(
          "primary.300",
          "gray.900"
        )}
        // minW={hideName ? "6rem" : "15rem"}
        // w={hideName ? "6rem" : "15rem"}
        transition="all 0.3s ease"
        onMouseOver={() => setHideName(false)}
        onMouseLeave={() => setHideName(true)}
        display={{ base: "none", lg: "block" }}
        style={{ position: "fixed", zIndex: 10 }}
      >
        <SidebarContent
          onClose={() => onClose()}
          display={{ base: "none", lg: "block" }}
          activePage={activePage}
          setActivePage={setActivePage}
          hideName={hideName}
          setHideName={setHideName}
        />

        <Drawer
          autoFocus={false}
          isOpen={isOpen}
          placement="left"
          onClose={onClose}
          returnFocusOnClose={false}
          onOverlayClick={onClose}
          size="full"
        >
          <DrawerContent>
            <SidebarContent
              onClose={onClose}
              activePage={activePage}
              setActivePage={setActivePage}
              hideName={hideName}
              setHideName={setHideName}
            />
          </DrawerContent>
        </Drawer>
      </Box>

      {/* Mobile Sidebar */}

      <Box display={{ base: "block", lg: "none" }}>
        <Drawer
          isOpen={openMobileSideDrawer}
          placement="left"
          onClose={setOpenMobileSideDrawer}
        >
          <DrawerOverlay />

          <DrawerContent maxW={"16rem"}>
            <SidebarContent
              onClose={() => onClose}
              activePage={activePage}
              setActivePage={setActivePage}
              hideName={false}
              setHideName={setHideName}
              setOpenMobileSideDrawer={setOpenMobileSideDrawer}
            />
          </DrawerContent>
        </Drawer>
      </Box>
    </>
  );
}

interface SidebarProps extends BoxProps {
  onClose: () => void;
  activePage: string;
  setActivePage: setActivePage;
  hideName: boolean;
  setOpenMobileSideDrawer?: any;
  setHideName: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}

const SidebarContent = ({
  activePage,
  setActivePage,
  hideName,
  setHideName,
  setOpenMobileSideDrawer,
  ...rest
}: SidebarProps) => {
  const {
    userRole,
    companyType,
    accountDetails,
  } = useContext(AppContext);

  const mobileSidebar = useBreakpointValue({
    lg: true,
  });

  const {
    isOpen: isPopupOpen,
    onClose: onPopupClose,
    onToggle: togglePopup,
  } = useDisclosure();

  const isMobileView = useBreakpointValue({
    base: false,
    lg: true,
  });

  function checkPermission(name?: string) {
    if (name === "") {
      return "flex";
    }

    const ans = accountDetails?.permission?.filter(
      (value: string) => value === name
    );

    if (ans?.length > 0) {
      return "flex";
    }

    return "none";
  }

  return (
    <Box
      bg={useColorModeValue(
        "primary.300",
        "gray.500"
      )}
      zIndex={10}
      borderRight="1px"
      borderRightColor={useColorModeValue(
        "primary.300",
        "gray.700"
      )}
      pos="fixed"
      h="full"
      {...rest}
    >
      {/* Logo */}

      <Flex
        h="20"
        alignItems="center"
        justifyContent="space-between"
        px="5"
      >
        <Flex alignItems="center">
          <Image
            bg="white"
            px="3px"
            borderRadius="5px"
            src={BASE_PATH + "/img/short-logo.png"}
            w={51}
          />

          {(!hideName || !mobileSidebar) && (
            <Box
              fontSize="md"
              ml={3}
              fontWeight={700}
              color="white"
            >
              Buyer App
            </Box>
          )}

          {/* {!mobileSidebar && (
            <Box
              fontSize="md"
              ml={3}
              fontWeight={700}
              color="white"
            >
              Buyer App
            </Box>
          )} */}
        </Flex>

        <CloseButton
          color="white"
          display={{ lg: "none" }}
          onClick={() => {
            if (setOpenMobileSideDrawer) {
              setOpenMobileSideDrawer(false);
            }
          }}
        />
      </Flex>

      <Box px="1rem" mb=".1rem">
        <Box
          h="2px"
          w="100%"
          backgroundImage="linear-gradient(to right, rgba(224, 225, 226, 0) 0% , #E0E1E2 50%, rgba(224, 225, 226, 0.1563) 100%)"
        />
      </Box>

      <Box
        overflowY={
          isMobileView ? "auto" : "hidden"
        }
        h="calc(100vh - 6rem)"
        className="customScrollBar"
        pt={5}
      >
        {OrganisationLinkItems.map((link: any) => (
          <NavItem
            key={link.name}
            name={link.name}
            display={checkPermission(
              link.permission
            )}
            active={link.name === activePage}
            icon={link.icon}
            url={link.url}
            setActivePage={setActivePage}
            hideName={
              mobileSidebar === undefined
                ? false
                : hideName === true
                  ? true
                  : false
            }
            setHideName={setHideName}
            setOpenMobileSideDrawer={
              setOpenMobileSideDrawer
            }
          >
            {link.name}
          </NavItem>
        ))}

        {/* Settings Divider */}

        <Box
          position="relative"
          display={{ base: "none", lg: "block" }}
        >
          <Box px="1rem" mb=".1rem">
            <Box
              mb={2}
              h="2px"
              w="100%"
              backgroundImage="linear-gradient(to right, rgba(224, 225, 226, 0) 0% , #E0E1E2 50%, rgba(224, 225, 226, 0.1563) 100%)"
            />
          </Box>

          {AdminLinkItems.map((link) => {
            const hasChildPermission = link.items?.some(
              (item) => checkPermission(item.permission) === "flex"
            );

            if (!hasChildPermission) return null;

            return (
              <Popover
                key={link.name}
                isOpen={isPopupOpen}
                onClose={onPopupClose}
                placement="right-end"
                closeOnBlur={true}
                gutter={8}
              >
                <PopoverTrigger>
                  <Box>
                    <AdminOption
                      active={
                        activePage === link.name ||
                        !!link.items?.some((item) => item.name === activePage)
                      }
                      name={link.name}
                      hideName={
                        mobileSidebar === undefined ? false : hideName === true
                      }
                      setHideName={setHideName}
                      setOpenMobileSideDrawer={setOpenMobileSideDrawer}
                      togglePopup={togglePopup}
                      handleOptionClick={togglePopup}
                    />
                  </Box>
                </PopoverTrigger>

                <Portal>
                  <PopoverContent
                    bg="primary.300"
                    border="1px solid"
                    borderColor="secondary.300"
                    w="auto"
                    zIndex="999"
                  >
                    <PopoverBody>
                      {link.items?.map((item: any) => (
                        <AdminMenuItems
                          key={item.name}
                          name={item.name}
                          display={checkPermission(item.permission)}
                          icon={item.icon}
                          url={item.url}
                          setActivePage={setActivePage}
                          hideName={false}
                          setHideName={setHideName}
                          setOpenMobileSideDrawer={setOpenMobileSideDrawer}
                          setIsPopupOpen={onPopupClose}
                          active={activePage === item.name}
                        />
                      ))}
                    </PopoverBody>
                  </PopoverContent>
                </Portal>
              </Popover>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

interface AdminItemProps extends FlexProps {
  name: string;
  icon: IconType;
  url?: string;
  setActivePage: setActivePage;
  hideName: boolean;
  setHideName: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setOpenMobileSideDrawer?: any;
  setIsPopupOpen: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  active: boolean;
  display?: string;
}

const AdminMenuItems = ({
  name,
  icon,
  setActivePage,
  setOpenMobileSideDrawer,
  setIsPopupOpen,
  active,
  display,
}: AdminItemProps) => {
  const isMobile = useBreakpointValue({
    base: true,
    lg: false,
  });

  return (
    <Link
      href="#"
      display={display}
      textDecoration="none"
      _focus={{ boxShadow: "none" }}
      _hover={{ textDecoration: "none" }}
      onClick={() => {
        if (
          isMobile &&
          setOpenMobileSideDrawer
        ) {
          setOpenMobileSideDrawer(false);
        }

        setActivePage(name);

        setIsPopupOpen(false);
      }}
    >
      <Flex
        align="center"
        p=".6rem"
        borderRadius="10px"
        cursor="pointer"
        color={
          active ? "white" : "secondary.400"
        }
        fontWeight="600"
        fontSize="sm"
        transition="all 0.25s ease"
        bg={
          active
            ? "secondary.300"
            : "transparent"
        }
        _hover={{
          bg: "secondary.300",
          color: "white",
        }}
      >
        <Icon as={icon} mr={3} />

        {name}
      </Flex>
    </Link>
  );
};

interface AdminOptionProps
  extends FlexProps {
  name: string;
  active: boolean;
  hideName: boolean;
  setHideName: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  setOpenMobileSideDrawer?: any;
  togglePopup: any;
  handleOptionClick: any;
}

const AdminOption = ({
  name,
  active,
  hideName,
  handleOptionClick,
}: AdminOptionProps) => {
  return (
    <Tooltip
      label={hideName ? name : ""}
      placement="right"
      hasArrow
      bg="secondary.300"
    >
      <Flex
        direction={hideName ? "column" : "row"}
        align="center"
        justify={
          hideName ? "center" : "flex-start"
        }
        p=".6rem"
        mx="2"
        ml={hideName ? "auto" : "15px"}
        mr={hideName ? "auto" : undefined}
        borderRadius="10px"
        cursor="pointer"
        color={
          active ? "white" : "secondary.400"
        }
        fontWeight="600"
        fontSize="sm"
        w={hideName ? "5.5rem" : "14.9rem"}
        transition="all 0.25s ease"
        bg={
          active
            ? "secondary.300"
            : "transparent"
        }
        mb={2}
        onClick={handleOptionClick}
        _hover={{
          bg: "secondary.300",
          color: "white",
        }}
      >
        <Icon
          as={MdOutlinePolicy}
          fontSize="1.2rem"
        />

        {!hideName && (
          <Box ml="12px">{name}</Box>
        )}

        {hideName && (
          <Box
            fontSize="xs"
            textAlign="center"
            mt="-0.3rem"
          >
            {name}
          </Box>
        )}
      </Flex>
    </Tooltip>
  );
};

interface NavItemProps extends FlexProps {
  name: string;
  icon: IconType;
  url?: string;
  children: string | number;
  active: boolean;
  setActivePage: setActivePage;
  hideName: boolean;
  setOpenMobileSideDrawer?: any;
  setHideName: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}

const NavItem = ({
  name,
  icon,
  active,
  setActivePage,
  hideName,
  setOpenMobileSideDrawer,
  children,
  ...rest
}: NavItemProps) => {
  const isMobile = useBreakpointValue(
    { base: true, lg: false },
    { fallback: "lg" }
  );

  const content = (
    <Link
      href="#"
      textDecoration="none"
      _focus={{ boxShadow: "none" }}
      _hover={{ textDecoration: "none" }}
      onClick={() => {
        if (
          isMobile &&
          setOpenMobileSideDrawer
        ) {
          setOpenMobileSideDrawer(false);
        }

        setActivePage(name);
      }}
    >
      <Flex
        direction={hideName ? "column" : "row"}
        align={
          hideName ? "center" : "center"
        }
        justify={
          hideName ? "center" : "flex-start"
        }
        p={hideName ? "0.4rem" : "0.6rem"}
        mx="2"
        ml={hideName ? "auto" : "15px"}
        mr={hideName ? "auto" : undefined}
        borderRadius="10px"
        role="group"
        cursor="pointer"
        color={
          active ? "white" : "secondary.400"
        }
        fontWeight="600"
        fontSize={{ base: "sm", lg: "sm" }}
        w={hideName ? "5.5rem" : "14.9rem"}
        minW={
          hideName ? "5.5rem" : undefined
        }
        textAlign={
          hideName ? "center" : "left"
        }
        transition="all 0.25s ease"
        mb={hideName ? 0 : 2}
        bg={
          active
            ? "secondary.300"
            : "transparent"
        }
        _hover={{
          bg: "secondary.300",
          color: "white",
          fontWeight: "600",
        }}
        _active={{
          bg: "secondary.300",
          color: "white",
          fontWeight: "600",
        }}
        {...rest}
      >
        <Box
          h="34px"
          w="34px"
          p="6px"
          borderRadius="10px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          mb={0}
          mx={hideName ? "auto" : undefined}
        >
          <Icon
            as={icon}
            fontSize="1.2rem"
            color="inherit"
          />
        </Box>

        {!hideName || isMobile ? (
          <Box
            ml={hideName ? 0 : "12px"}
            whiteSpace="nowrap"
          >
            {children}
          </Box>
        ) : (
          <Box
            fontSize="xs"
            whiteSpace="nowrap"
            textAlign="center"
            overflow="hidden"
            textOverflow="ellipsis"
            maxWidth="100%"
            px="2px"
            mt="-0.3rem"
            _groupHover={{
              color: "white",
            }}
          >
            {name}
          </Box>
        )}
      </Flex>
    </Link>
  );

  if (hideName && !isMobile) {
    return (
      <Tooltip
        label={name}
        placement="right"
        fontSize="xs"
        hasArrow
        bg="secondary.300"
        color="white"
        borderRadius="6px"
        openDelay={300}
      >
        {content}
      </Tooltip>
    );
  }

  return content;
};

export function getFirstAllowedPage(accountDetails: any) {
  function checkPermission(name?: string) {
    if (!name) return false;
    return accountDetails?.permission?.includes(name);
  }

  // 1. Check organisation items
  const orgItem = OrganisationLinkItems.find((link) =>
    checkPermission(link.permission)
  );
  if (orgItem) return orgItem.name;

  // 2. Check admin items (like Settings -> Users)
  for (const link of AdminLinkItems) {
    const child = link.items?.find((item) =>
      checkPermission(item.permission)
    );
    if (child) return child.name;
  }

  return null; // no allowed page
}